/** Longest rule name the backend accepts. */
export const PURCHASE_PRICE_RULE_NAME_MAX_LENGTH = 100;
